import { selectAuthentication } from '../../../../duck/selectors';
import {
    createApiCallObject,
    deleet,
    get,
    put,
} from '../../../../../utilities/apiUtils';
import { Dispatch } from 'redux';
import { State } from '../../../../../state/store';
import { handleApiCallAndParseData } from '../../../../../utilities/utils';
import {
    FcmToken,
    NotificationSettings,
    PublicId,
} from '../../../../types/common';
import {
    deleteFcmTokenCompleted,
    fetchNotificationSettingsCompleted,
    fetchNotificationSettingsError,
    fetchNotificationSettingsPending,
    toggleFcmTokenCompleted,
    toggleFcmTokenError,
    toggleFcmTokenPending,
    updateFcmTokenCompleted,
    updateNotificationPermissionCompleted,
} from './reducer';
import { requestNotificationPermission } from '../../../../../utilities/wrapperUtils';

export function updateFcmToken(
    token: string,
    deviceId: string,
    deviceName: string
) {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        const auth = selectAuthentication(getState());
        if (!auth) return;
        put(
            `/api/persons/update-fcm-token?token=${token}&deviceId=${deviceId}&deviceName=${deviceName}`,
            createApiCallObject(dispatch, 'updateFcmToken'),
            {},
            auth
        )
            .then((token) => token.json())
            .then((token) => dispatch(updateFcmTokenCompleted(token)));
    };
}

export function updateNotificationPermission(permitted: boolean) {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        put(
            `/api/persons/update-notification-permission?permitted=${permitted}`,
            createApiCallObject(dispatch, 'updatePermission'),
            {},
            selectAuthentication(getState())
        )
            .then(() => {
                if (permitted) {
                    requestNotificationPermission();
                }
                dispatch(updateNotificationPermissionCompleted(permitted));
            })
            .catch(console.error);
    };
}

export function toggleFcmToken(tokenId: PublicId, enabled: boolean) {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        dispatch(toggleFcmTokenPending());
        handleApiCallAndParseData(
            put(
                `/api/persons/toggle-fcm-token/${tokenId}?enabled=${enabled}`,
                createApiCallObject(dispatch, 'toggleFcmToken'),
                {},
                selectAuthentication(getState())
            ),
            dispatch,
            (token: FcmToken) => dispatch(toggleFcmTokenCompleted(token)),
            (error: any) => {
                dispatch(toggleFcmTokenError());
                console.error(error);
            }
        );
    };
}

export function deleteFcmToken(tokenId: PublicId) {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        deleet(
            `/api/persons/delete-fcm-token/${tokenId}`,
            createApiCallObject(dispatch, 'deleteFcmToken'),
            {},
            selectAuthentication(getState())
        )
            .then(() => dispatch(deleteFcmTokenCompleted(tokenId)))
            .catch(console.error);
    };
}

export function fetchNotificationSettings() {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        dispatch(fetchNotificationSettingsPending());
        handleApiCallAndParseData(
            get(
                `/api/persons/notification-settings`,
                createApiCallObject(dispatch, 'notificationSettings'),
                selectAuthentication(getState())
            ),
            dispatch,
            (settings: NotificationSettings) => {
                dispatch(fetchNotificationSettingsCompleted(settings));
            },
            (error: any) => {
                console.error(error);
                dispatch(fetchNotificationSettingsError());
            }
        );
    };
}
